<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

const DEBOUNCE_MS = 150;

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Je Instanz eigener Timer, eigene Suchfolge und eigener Geocoder.
    this.timer = null;
    this.requestSequence = 0;
    this.geocoder = null;
    this.geocoderReady = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.stopSearch();
  },

  watch: {
    search(val) {
      if (!val || (typeof val === "string" && val.trim() === "")) {
        this.stopSearch();
        this.items = [];
        return;
      }

      if (this.select && typeof this.select === "object" && val === this.select.text) {
        return;
      }

      this.querySelections(val);
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // Beendet Timer und laufende Anfrage; verspätete Antworten werden verworfen.
    stopSearch() {
      this.requestSequence++;

      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.stopSearch();

      const sequence = this.requestSequence;
      this.loading = true;

      this.timer = setTimeout(() => {
        this.timer = null;

        this.geocoderReady.then(geocoder => {
          if (sequence !== this.requestSequence) {
            return null;
          }

          return geocoder.autocomplete(value);
        }).then(items => {
          if (sequence !== this.requestSequence || items === null) {
            return;
          }

          this.items = items.slice();
          this.loading = false;
        }).catch(() => {
          if (sequence !== this.requestSequence) {
            return;
          }

          this.items = [];
          this.loading = false;
        });
      }, DEBOUNCE_MS);
    },

    change(o) {
      this.stopSearch();
      this.$emit("change", o);
    }
  }
};
</script>
